<template>
  <blockquote class="my-6 pl-4 border-l-2 border-primary">
    <div class="flex gap-3 items-start">
      <Icon v-if="shouldShowIcon" name="tabler:quote" size="20" class="text-primary shrink-0 mt-0.5" aria-hidden="true" />
      <div class="flex-1">
        <div class="text-foreground/80 italic leading-relaxed">
          <slot />
        </div>
        <footer v-if="author || source" class="mt-3 text-sm text-muted-foreground not-italic">
          <cite v-if="author" class="font-medium text-foreground">{{ author }}</cite>
          <span v-if="author && source"> — </span>
          <span v-if="source">{{ source }}</span>
        </footer>
      </div>
    </div>
  </blockquote>
</template>

<script setup lang="ts">
import { computed } from 'vue';
/**
 * Blog Quote Component
 *
 * A blockquote component for MDC (Markdown Components) that supports
 * different styles, author attribution, and source citation.
 */

interface Props {
  author?: string;
  source?: string;
  showIcon?: boolean | string;
  type?: 'default' | 'testimonial' | 'highlight' | 'minimal';
}

const props = withDefaults(defineProps<Props>(), {
  showIcon: true,
  type: 'default',
});

// Helper to convert string "true"/"false" to boolean
const toBool = (val: boolean | string | undefined): boolean => {
  if (typeof val === 'string') return val === 'true';
  return !!val;
};

const shouldShowIcon = computed(() => toBool(props.showIcon));
</script>
